module.exports = __webpack_public_path__ + "img/card-t8.a19b521a.png";